import { createFileRoute } from '@tanstack/react-router';
import { useEffect, useRef } from 'react';

import { MyDuos } from '@/features/duos/components/myDuos';
import { getDuosOptions, useGetDuos } from '@/features/duos/hooks/useGetDuos';
import { useGetUnreadNotifications } from '@/features/notifications/hooks/useGetUnreadNotifications';
import { getUnreadNotificationsOptions } from '@/features/notifications/hooks/useGetUnreadNotifications/getUnreadNotifications.options';
import { useMarkNotificationsAsRead } from '@/features/notifications/hooks/useMarkNotificationsAsRead';
import { usePromptNotificationPermission } from '@/features/notifications/hooks/usePromptNotificationPermission';
import { MainLayout } from '@/shared/components/mainLayout';
import { PageHeader } from '@/shared/components/pageHeader';

export const Route = createFileRoute('/_protected/_app/_mainLayout/my-duos/')({
  component: RouteComponent,
  loader: async ({ context }) => {
    await Promise.all([
      context.queryClient.ensureInfiniteQueryData(getDuosOptions()),
      context.queryClient.ensureQueryData(
        getUnreadNotificationsOptions({ group: 'DUO' }),
      ),
    ]);
  },
  head: () => ({
    meta: [{ title: 'My Duos' }],
  }),
});

function RouteComponent() {
  const { data: cardsLength } = useGetDuos({
    options: { select: ({ pages }) => pages.at(0)?.page.totalElements ?? 0 },
  });

  const { data: unreadCount } = useGetUnreadNotifications({
    group: 'DUO',
    options: { select: data => data.page.totalElements },
  });
  const { mutate: markAsRead } = useMarkNotificationsAsRead();

  const unreadCountRef = useRef(unreadCount);
  useEffect(() => {
    unreadCountRef.current = unreadCount;
  }, [unreadCount]);

  useEffect(() => {
    return () => {
      if (unreadCountRef.current > 0) {
        markAsRead('DUO');
      }
    };
  }, [markAsRead]);

  usePromptNotificationPermission(
    'myDuos',
    Boolean(cardsLength && cardsLength > 0),
  );

  return (
    <MainLayout.Root>
      <PageHeader.Root>
        <PageHeader.Title>My Duos Collection ({cardsLength})</PageHeader.Title>
        <PageHeader.NonToxicBadge />
      </PageHeader.Root>
      <MainLayout.Content className="mt-5 w-full pt-5">
        <MyDuos />
      </MainLayout.Content>
    </MainLayout.Root>
  );
}
